
export function typeChecker(unknownType) {
  // 使用base Object 建構子的prototype上之toString方法，
  // 並以call將目標做為this傳入，就能得到"[Object xxx]"格式的字串
  // 裡面的xxx可以用來判定類型
  // Number, String, Array, Function 等等內建建構子的prototype
  // 都有自己的toString方法
  // 但行為和Object 建構子的不太一樣，無法做為判斷型別用
  // 所以需要直接指定Object.prototype
  const type = Object.prototype.toString.call(unknownType),
        typeString = type.slice(type.indexOf(' ') + 1, type.lastIndexOf(']'));
  
  // switch(type) {
  //   case 'Number':
      
  //     break;
  //   case 'String':
      
  //     break;
  //   case 'Boolean':
      
  //     break;
  //   case 'Array':
      
  //     break;
  //   case 'Object':
      
  //     break;
  //   case 'Undefined':
      
  //     break;
  //   case 'Null':
      
  //     break;
  //   default:
      
  // }

  return typeString;
}


// WEBPACK FOOTER //
// ./src/commonJS/typeChecker.js